import classNames from 'clsx';
import { type ChildAndClassNameProps } from '../types';
import { Body3 } from '../typography';
import { content, root } from './DividerLine.css';

export function DividerLine(props: ChildAndClassNameProps) {
  const { className, children, ...rest } = props;

  return (
    <div className={classNames(root, className)} {...rest}>
      {children && <Body3 className={content}>{children}</Body3>}
    </div>
  );
}
